import { useTranslation } from 'react-i18next'
import { useDialog } from '../../../../store/api/hooks/dialogHook'
import { ExperimentDetailsHeaderProps } from '../../types'
import { useCommonApi } from '../../../../store/api/hooks/commonApiHook'
import { useEffect, useState } from 'react'
import Text from '../../../../elements/Typo/Text'
import { getShortUserName, isBuisenessOwnerRepectToExperiment, isMyExperiment, trackEvent } from '../../../../_common/functions'
import { OptionI } from '../../../../_config/types'
import { ExperimentViewDesign } from '../..'
import moment from 'moment'
import Filter from '../HeaderSection/Filter'
import Icon from '../../../../components/icons'
import RecurringMeasurementButton from '../RecurringMeasurementButton'
import SharedWith from '../HeaderSection/SharedWith'
import HeaderCards from '../HeaderSection/Cards'
import HypothesishSection from '../HeaderSection/Hypothesis'
import DownloadFiles from '../HeaderSection/DownloadFiles'
import AdvanceConfigurationButton from '../advanceConfigurationButton'
import { useExperimentApi } from '../../../../store/api/hooks/experimentApiHook'
import CaptureDecision from '../HeaderSection/CaptureDecision'
import { EXPERIMENT_TYPES } from '../../../../_common/constant'
import MteCards from '../HeaderSection/MteCards'
import DmlCards from '../HeaderSection/DMLCards'

const HeaderLargeView: React.FC<ExperimentDetailsHeaderProps> = ({
    _ref,
    kpiImpactsData,
    experimentDetails,
    groupOptions,
    selectedGroup,
    setSelectedGroup,
    dropdownOptions,
    selectedKPI,
    setSelectedKPI,
    setSelectedDateRange,
    selectedDateRange,
    setSelectedConfig,
    setShowAlertMsg,
    user,
    comments,
    mteCardData,
    dmlCardData,
    openComment,
    selectedConfig,
    nMatches,
    cliper,
    MeasurementAdvanceConfig,
    getCStatus,
    cardDetails,
    cardLoading,
    analysisData,
    _handleShowExperimentStatus,
    setIsInconclusiveModalOpen,
    setIsNoImpactModalOpen,
    toDownloadAsReport,
    onUpdate,
}) => {
    const { t } = useTranslation()
    const dialog = useDialog()

    const commonAPI = useCommonApi()
    const experimentAPI = useExperimentApi()
    const [ownerAccess, setOwnerAccess] = useState<boolean>(false)

    const getExperimentAccess = () => {
        commonAPI.getExperimentAccess(
            { literal: experimentDetails.experiment_literal },
            (resp: any) => {
                setOwnerAccess(resp.data.has_access)
            },
            (error: any) => {},
        )
    }

    useEffect(() => {
        if (experimentDetails.experiment_literal) {
            getExperimentAccess()
        }
    }, [experimentDetails])
    const markasIsBuPriority = () => {
        experimentAPI.markasBuPriority(
            { literal: experimentDetails.experiment_literal, is_bu_prioritize: true },
            (resp: any) => {
                if (resp?.data?.success === true) {
                    experimentDetails.is_bu_prioritize_experiment = true
                    onUpdate()
                }
            },
            (error: any) => {},
        )
    }
    const markasBuPriority = () => {
        dialog.confirm({
            type: 'delete',
            title: t('Mark as BU Priority'),
            message: t('Are you sure you want to mark this experiment as <br /><strong>BU Priority?</strong> '),
            warning: t('You cannot revert this action for this experiment.'),
            confirmButtonLabel: t('Yes, confirm'),
            onConfirm: () => {
                markasIsBuPriority()
            },
            onCancel: () => {
                console.log('No')
            },
        })
    }

    const isNoImpactWithCustomKPI = () => {
        if (kpiImpactsData[0]?.experiment_status?.search('No_impact') == 0) {
            // if (selectedKPI?.is_custom || selectedKPI?.literral_value === 'Total Distribution') {
            //     return true
            // } else {
            //     return false
            // }
            return true
        } else {
            return false
        }
    }

    const getHeaderCards = () => {
        if (experimentDetails?.experiment_type?.title == EXPERIMENT_TYPES.MTE.title) {
            return <MteCards mteCardData={mteCardData} />
        }
        if (experimentDetails?.experiment_type?.title == EXPERIMENT_TYPES.DML.title) {
            return <DmlCards dmlCardData={dmlCardData} />
        }
        return (
            <HeaderCards
                progressBarStyle={{
                    root: { transform: 'rotate(0.75turn)' },
                    path: { stroke: 'white', strokeLinecap: 'butt' },
                    trail: { stroke: '#C4C4C4', strokeLinecap: 'butt' },
                    text: { fill: 'black', transform: 'rotate(90deg)', transformOrigin: '50% 50%', dominantBaseline: 'ideographic', fontWeight: 'bold', fontSize: '0.8rem' },
                }}
                cardDetails={cardDetails}
                experiment={experimentDetails}
                selectedKPI={selectedKPI}
                literal={experimentDetails?.experiment_literal}
                onUpdate={onUpdate}
                ownerAccess={ownerAccess}
                cardLoading={cardLoading}
            />
        )
    }

    return (
        <div className=" px-2 py-2" ref={_ref}>
            <div className="grid grid-cols-5 gap-4">
                <div className="col-span-3 flex flex-col gap-y-[0.581vw]">
                    <div className="flex gap-3">
                        <div className="bg-[#F1F1F1] badge badge-warning">
                            <Text className="!text-[0.591rem] font-normal">{t('ID:')}</Text>&nbsp;
                            <Text className="!text-[0.591rem] font-normal">{experimentDetails?.experiment_literal}</Text>
                        </div>
                        <div className="bg-primary !text-[0.545rem] badge badge-warning font-normal"> {experimentDetails?.exp_type_status}</div>

                        <Text size="xl" className="font-semibold !text-[0.909rem] truncate" title={experimentDetails?.experiment_name}>
                            {experimentDetails?.experiment_name}
                        </Text>
                    </div>
                    <div className="flex items-center">
                        <div className="flex gap-3 items-center pr-2">
                            <Text size="xs" className="!text-[0.591rem]">
                                {t('Created By :')}
                            </Text>
                            <div className="flex items-center gap-1">
                                <div className="h-[1.182rem] w-[1.182rem] rounded-[1.045rem] bg-primary flex items-center justify-center">
                                    <span className="font-bold text-[0.455rem]">{getShortUserName(experimentDetails?.user?.first_name, experimentDetails?.user?.last_name)}</span>
                                </div>
                                <Text size="xs" className="font-semibold !text-[0.591rem]">
                                    {experimentDetails?.user?.first_name + ' ' + experimentDetails?.user?.last_name}
                                </Text>
                            </div>
                        </div>
                        {(kpiImpactsData[0]?.experiment_status?.search('Inconclusive') == 0 || isNoImpactWithCustomKPI()) && (
                            <div className="flex gap-1 items-center justify-end border-l border-[#BEBEBE] pl-2">
                                <Text className="items-center font-normal !text-[0.591rem]">{t('Click here to know why :')}</Text>
                                <Text
                                    className="underline cursor-pointer items-center font-semibold !text-[#F23F44] !text-[0.591rem]"
                                    onClick={() => {
                                        if (isNoImpactWithCustomKPI()) {
                                            trackEvent('experiment_details_no_impact_link_clicked', { experiment_literal: experimentDetails?.experiment_literal })
                                            setIsNoImpactModalOpen(true)
                                        } else {
                                            trackEvent('experiment_details_inconclusive_link_clicked', { experiment_literal: experimentDetails?.experiment_literal })
                                            setIsInconclusiveModalOpen(true)
                                        }
                                    }}
                                >
                                    {kpiImpactsData[0]?.experiment_status?.replaceAll('_', ' ')}
                                </Text>
                            </div>
                        )}
                    </div>

                    <Filter
                        experiment={experimentDetails}
                        groupOptions={groupOptions as any}
                        selectedGroup={selectedGroup as any}
                        onGroupChange={(e: OptionI) => {
                            trackEvent('experiment_details_group_changed', { experiment_literal: experimentDetails?.experiment_literal, group_name: e?.label, previous_group: selectedGroup?.label })
                            setSelectedConfig({ ...selectedConfig, value: null })
                            setSelectedGroup(e)
                        }}
                        kpiOptions={dropdownOptions}
                        selectedKPI={selectedKPI ? [selectedKPI] : []}
                        setShowAlertMsg={setShowAlertMsg as any}
                        onKpiChange={(e: any) => {
                            trackEvent('experiment_details_kpi_changed', { experiment_literal: experimentDetails?.experiment_literal, kpi_name: e?.label, kpi_type: e?.kpi_type })
                            setSelectedConfig({ ...selectedConfig, value: null })
                            setSelectedKPI(e)
                            // setSelectedConfig(e?.kpi_type === 'Continuous' ? advanceConfigOptions[0] : undefined)
                        }}
                        shortView={false}
                        onDateChange={(e: any) => {
                            if (e?.length) {
                                setSelectedDateRange([moment(e[0]).format('YYYY-MM-DD'), moment(e[1]).format('YYYY-MM-DD')])
                            } else {
                                setSelectedDateRange([])
                            }
                        }}
                        selectedDateRange={selectedDateRange}
                        toDownloadAsReport={toDownloadAsReport}
                    />
                </div>
                <div className="col-span-2 flex flex-col items-end justify-center gap-y-[0.781vw]">
                    <div className="flex gap-3 items-center justify-center ">
                        {!experimentDetails.is_recurring_child_experiment && (
                            <>
                                {ownerAccess && <CaptureDecision experiment={experimentDetails} />}
                                {isBuisenessOwnerRepectToExperiment(experimentDetails, user?.user_literal) && !isMyExperiment(experimentDetails, user?.user_literal) && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            trackEvent('experiment_details_review_clicked', { experiment_literal: experimentDetails?.experiment_literal, reviewer_literal: user?.user_literal })
                                            openComment()
                                        }}
                                        className="flex gap-[0.33rem] bg-[#FFF] items-center"
                                    >
                                        <div className="h-[1.182rem] w-[1.182rem] rounded-[1.045rem] bg-primary flex items-center justify-center">
                                            <Icon name="note" size={0.545}></Icon>
                                        </div>
                                        <Text size="xs" className="!text-[0.591rem] !font-semibold">
                                            {t('Review')}
                                        </Text>
                                    </button>
                                )}
                                {isMyExperiment(experimentDetails, user?.user_literal) && comments.length > 0 && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            trackEvent('experiment_details_view_note_clicked', { experiment_literal: experimentDetails?.experiment_literal, comment_count: comments?.length })
                                            openComment()
                                        }}
                                        className="flex gap-[0.33rem] bg-[#FFF] items-center"
                                    >
                                        <div className="h-[1.182rem] w-[1.182rem] rounded-[1.045rem] bg-primary flex items-center justify-center">
                                            <Icon name="note" size={0.545}></Icon>
                                        </div>
                                        <Text size="xs" className="!text-[0.591rem] !font-semibold">
                                            {t('View Note')}
                                        </Text>
                                    </button>
                                )}

                                {selectedKPI?.kpi_literal !== 'kpi_004' && selectedKPI?.kpi_literal !== 'kpi_005' && selectedKPI?.kpi_literal !== 'kpi_006' && !experimentDetails?.is_sdk && (
                                    <AdvanceConfigurationButton
                                        selectedConfig={selectedConfig}
                                        setSelectedConfig={setSelectedConfig}
                                        experimentDetails={experimentDetails}
                                        nMatches={nMatches}
                                        cliper={cliper}
                                        MeasurementAdvanceConfig={MeasurementAdvanceConfig}
                                        getCStatus={getCStatus}
                                    />
                                )}
                            </>
                        )}

                        <DownloadFiles experiment={experimentDetails} />
                    </div>
                    {!experimentDetails.is_recurring_child_experiment && (
                        <div className="flex gap-3 items-center justify-center">
                            {ownerAccess && !experimentDetails.is_bu_prioritize_experiment && (
                                <label className="flex items-center gap-3 px-[0.583rem] py-[0.417rem] bg-black rounded-md cursor-pointer h-[1.667rem] ">
                                    <input
                                        type="checkbox"
                                        className="peer sr-only"
                                        onClick={() => {
                                            trackEvent('experiment_details_mark_bu_priority', { experiment_literal: experimentDetails?.experiment_literal, experiment_name: experimentDetails?.experiment_name })
                                            markasBuPriority()
                                        }}
                                        checked={experimentDetails.is_bu_prioritize_experiment}
                                        disabled={experimentDetails.is_bu_prioritize_experiment}
                                    />

                                    {/* Checkbox box */}
                                    <span className="relative h-[0.833rem] w-[0.833rem] rounded-[0.208rem] border border-white bg-black flex items-center justify-center transition-colors duration-150 peer-checked:bg-yellow-400 peer-checked:border-yellow-400">
                                        {/* Checkmark */}
                                        <svg className="absolute h-3 w-3 text-black opacity-40 transition-opacity duration-150 peer-checked:opacity-100" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 11.586l7.293-7.293a1 1 0 011.414 0z" />
                                        </svg>
                                    </span>

                                    <span className="text-white text-[0.542rem] whitespace-nowrap">{experimentDetails.is_bu_prioritize_experiment ? t('Mark BU Priority') : t('Mark as BU Priority')}</span>
                                </label>
                            )}

                            {experimentDetails.is_bu_prioritize_experiment && (
                                <label className="flex items-center gap-3 px-[0.583rem] py-[0.417rem] bg-black rounded-md cursor-default w-[7.875rem]  h-[1.667rem] ">
                                    <input type="checkbox" className="peer sr-only" onClick={markasBuPriority} checked={experimentDetails.is_bu_prioritize_experiment} disabled={experimentDetails.is_bu_prioritize_experiment} />

                                    {/* Checkbox box */}
                                    <span className="relative h-[0.833rem] w-[0.833rem] rounded-[0.208rem] border border-white bg-black flex items-center justify-center transition-colors duration-150 peer-checked:bg-yellow-400 peer-checked:border-yellow-400">
                                        {/* Checkmark */}
                                        <svg className="absolute h-3 w-3 text-black opacity-40 transition-opacity duration-150 peer-checked:opacity-100" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 11.586l7.293-7.293a1 1 0 011.414 0z" />
                                        </svg>
                                    </span>

                                    <span className="text-white text-[0.542rem]">{experimentDetails.is_bu_prioritize_experiment ? t('Mark BU Priority') : t('Mark as BU Priority')}</span>
                                </label>
                            )}

                            {ownerAccess && <RecurringMeasurementButton experiment={experimentDetails} ownerAccess={ownerAccess} />}

                            <SharedWith experiment={experimentDetails} />
                            {/* <Icon name={headerExpend ? 'down' : 'up'} onClick={() => setHeaderExpend(!headerExpend)}></Icon> */}
                        </div>
                    )}
                </div>
            </div>
            <div className="grid grid-cols-6 gap-3 items-center mt-2">
                <div className="col-span-4">{getHeaderCards()}</div>
                <ExperimentViewDesign
                    analysisData={analysisData}
                    experiment={experimentDetails}
                    _handleShowExperimentStatus={() => {
                        trackEvent('experiment_details_view_status_clicked', { experiment_literal: experimentDetails?.experiment_literal, status: experimentDetails?.status_text })
                        ;(_handleShowExperimentStatus as any)()
                    }}
                />
                <div className="col-span-1">
                    <HypothesishSection
                        experiment={experimentDetails}
                        success={() => {
                            onUpdate()
                        }}
                        selectedGroup={(selectedGroup?.value as any) ?? null}
                    />
                </div>
            </div>
        </div>
    )
}

export default HeaderLargeView
